var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-empty-pattern */
import { Button, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { ButtonWrapper, CustomTextField, GridWrapper, Wrapper, } from './Groups.Styles';
var columns = [
    {
        field: 'name',
        headerName: 'Group Name',
        flex: 1,
        editable: true
    },
];
export var Groups = function (_a) {
    var open = _a.open, onClose = _a.onClose, groups = _a.groups, isReadOnly = _a.isReadOnly, onAddGroup = _a.onAddGroup, onEditGroup = _a.onEditGroup, onDeleteGroup = _a.onDeleteGroup;
    var _b = useState(open), openModal = _b[0], setOpenModal = _b[1];
    var _c = useState(''), name = _c[0], setName = _c[1];
    var _d = useState(false), error = _d[0], setError = _d[1];
    var _e = useState([]), selectedRows = _e[0], setSelectedRows = _e[1];
    var handleClose = function () {
        setOpenModal(false);
        onClose();
    };
    useEffect(function () {
        setOpenModal(open);
    }, [open]);
    useEffect(function () {
        reSetNameValue();
    }, [groups]);
    var getNameError = function () {
        var _error = '';
        if (groups.find(function (r) { return r.name === name; })) {
            _error = 'Already Exists';
        }
        return _error;
    };
    var reSetNameValue = function () {
        setName('');
    };
    var addAttributes = function () {
        onAddGroup({ name: name });
    };
    var editGroups = function (data) {
        var row = groups.find(function (row) { return row.id === data.id; });
        onEditGroup({ name: data.value }, data.id, row);
    };
    var deleteAttributes = function () {
        var _rows = __spreadArrays(groups);
        selectedRows.forEach(function (row_id) {
            onDeleteGroup(row_id);
        });
    };
    var onHandleName = function (name) {
        setName(name);
    };
    return (React.createElement(Dialog, { open: openModal, onClose: function () { return handleClose(); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description', maxWidth: 'md' },
        React.createElement(DialogTitle, { id: 'alert-delete' }, "Groups"),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: 'alert-dialog-description' },
                React.createElement(Wrapper, null,
                    React.createElement(GridWrapper, null,
                        React.createElement(DataGrid, { rows: groups, columns: columns, pageSize: 5, rowsPerPageOptions: [5], checkboxSelection: true, disableSelectionOnClick: true, autoHeight: true, density: 'compact', onSelectionModelChange: function (e) { return setSelectedRows(e); }, onCellEditCommit: function (e) {
                                editGroups(e);
                            } })),
                    React.createElement(ButtonWrapper, null,
                        React.createElement(Button, { variant: 'outlined', color: 'primary', disabled: selectedRows.length <= 0, onClick: function () { return deleteAttributes(); } }, "Delete Groups(s)")),
                    React.createElement(Divider, null),
                    React.createElement(ButtonWrapper, null,
                        React.createElement(CustomTextField, { label: 'Group Name', placeholder: 'Name', variant: 'outlined', margin: 'dense', fullWidth: true, InputLabelProps: {
                                shrink: true
                            }, InputProps: {
                                notched: false
                            }, value: name, onChange: function (e) { return onHandleName(e.target.value); }, error: !!groups.find(function (r) { return r.name === name; }) || (error && !name), helperText: getNameError() })),
                    React.createElement(ButtonWrapper, null,
                        React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () {
                                if (groups.find(function (r) { return r.name === name; }) || !name) {
                                    setError(true);
                                }
                                else {
                                    setError(false);
                                    addAttributes();
                                }
                            } }, "Add New Group")),
                    React.createElement(Divider, null)))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: function () { return handleClose(); }, color: 'primary' }, "Close"))));
};
Groups.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=Groups.js.map